export default {"src":"/_next/static/media/x.d325c608.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};